export default __webpack_public_path__ + "static/media/Screen_Infrastructure_04_03.538dc8bf.mp4";